import { render } from "./App.vue?vue&type=template&id=015d330b&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=015d330b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1943814799/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015d330b"]])

export default __exports__